module.exports = __webpack_public_path__ + "static/media/ic-mais-vida-menu.04021b7a.svg";